import axios from "axios";

axios.defaults.baseURL = "https://admin-mdc-home-fnneu.ondigitalocean.app";

const axiosFetcher = (url:string) => {
  return axios.get(url).then((res) => res.data);
}

export default axiosFetcher;
